import { createTelemetryAPI } from '~/utils/telemetry'

export const benchmarkReportTelemetry = createTelemetryAPI(({ track }) => ({
  toggleMainMetric(name: string, open: boolean) {
    return track('Benchmark Report Detail: Toggle Main Metric Details', {
      name,
      open
    })
  },
  toggleRelatedMetrics(name: string, open: boolean) {
    return track('Benchmark Report Detail: Toggle Related Metrics', {
      name,
      open
    })
  },
  toggleAdvice(id: number, name: string, open: boolean) {
    return track('Benchmark Report Detail: Toggle Advice', {
      id,
      name,
      open
    })
  }
}))
